import axios from "axios";
import { StorageTokenJWT } from "./StorageService";

const serverLink = process.env.REACT_APP_SERVER_LINK;

export const PostLogin = async (path, form) => {
    //const jwt = "hT8jR2w5oL4r1P3yU6nQ7x9eC2mFvAa";
    let resOptions = {
        headers: {
            "Content-Type": "application/json",
            Authorization: process.env.REACT_APP_API_TOKEN,
        },
    };

    const axiosInstance = axios.create({
        maxContentLength: 50 * 1024 * 1024, // 50MB
        maxBodyLength: 50 * 1024 * 1024, // 50MB
    });

    let res = await axiosInstance
        .post(`${serverLink}/${path}`, form, resOptions)
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });

    return res;
};


export const Post = async (path, form) => {
    const jwt = await StorageTokenJWT();
    //const jwt = "hT8jR2w5oL4r1P3yU6nQ7x9eC2mFvAa";
    let resOptions = {
        headers: {
            "Content-Type": "application/json",
            Authorization: process.env.REACT_APP_API_TOKEN,
            // Authorization: `Bearer ${jwt}`,
            // user_token: jwt,
        },
    };

    const axiosInstance = axios.create({
        maxContentLength: 50 * 1024 * 1024, // 50MB
        maxBodyLength: 50 * 1024 * 1024, // 50MB
    });

    let res = await axiosInstance
        .post(`${serverLink}/${path}`, form, resOptions)
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });

    return res;
};

export const Get = async (path, param) => {
    const jwt = await StorageTokenJWT();
    let resOptions = {
        method: "POST",
        async: true,

        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt}`,
        },
    };
    let parameterizedURL = "";
    if (param) {
        // Convert Json to Parameter URL
        const queryParams = Object.keys(param)
            .map((key) => `${key}=${encodeURIComponent(param[key])}`)
            .join("&");
        parameterizedURL = `?${queryParams}`;
    }
    let res = await axios
        .post(`${serverLink}/${path}${parameterizedURL}`, {}, resOptions)
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });

    return res;
};

export const PostFile = async (path, form, params) => {
    const jwt = await StorageTokenJWT();
    let resOptions = {
        headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${jwt}`,
        },
    };

    let res = await axios
        .post(`${serverLink}/${path}`, form, resOptions)
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });

    return res;
};
